<template>
    <HeaderContent title="Program" />

    <TransportarionForm
        v-if="modalTransportation"
        :modal="modalTransportation"
        :selectedData="selectedTransportation"
        :defaultPax="formProgram.pax"
        @update:modal="updateModalTransportation"
        @addOrUpdate="addOrUpdateTransportation"
    ></TransportarionForm>

    <AccommodationForm
        v-if="modalAccomodation"
        :modal="modalAccomodation"
        :selectedData="selectedAccomodation"
        :defaultPax="formProgram.pax"
        @update:modal="updateModalAccomodation"
        @addOrUpdate="addOrUpdateAccomodation"
    ></AccommodationForm>

    <ActivityForm
        v-if="modalActivity"
        :modal="modalActivity"
        :selectedData="selectedActivity"
        :defaultPax="formProgram.pax"
        @update:modal="updateModalActivity"
        @addOrUpdate="addOrUpdateActivity"
    ></ActivityForm>

    <MealForm
        v-if="modalMeal"
        :modal="modalMeal"
        :selectedData="selectedMeal"
        :defaultPax="formProgram.pax"
        @update:modal="updateModalMeal"
        @addOrUpdate="addOrUpdateMeal"
    ></MealForm>

    <BForm @submit.stop.prevent>
        <BCard>
            <BTabs content-class="mt-3">
                <BTab title="Detail">
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <BFormGroup
                                label-cols-sm="4"
                                label-cols-lg="3"
                                content-cols-sm
                                content-cols-lg="7"
                                label="Program Name *"
                                label-for="name"
                            >
                                <BFormInput
                                    v-model="formProgram.name"
                                    type="text"
                                    id="name"
                                    placeholder="Enter Program Name"
                                    :class="{
                                        'is-invalid':
                                            vProgram$.form.name.$dirty &&
                                            vProgram$.form.name.$invalid,
                                    }"
                                />
                                <BFormInvalidFeedback
                                    :state="
                                        vProgram$.form.name.$dirty &&
                                        vProgram$.form.name.$invalid
                                    "
                                >
                                    {{
                                        vProgram$.form.name.$errors[0]?.$message
                                    }}
                                </BFormInvalidFeedback>
                            </BFormGroup>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <BFormGroup
                                label-cols-sm="4"
                                label-cols-lg="3"
                                content-cols-sm
                                content-cols-lg="7"
                                label="Pax *"
                                label-for="pax"
                            >
                                <BFormInput
                                    v-model="formProgram.pax"
                                    type="number"
                                    id="pax"
                                    placeholder="Enter Pax"
                                    :class="{
                                        'is-invalid':
                                            vProgram$.form.pax.$dirty &&
                                            vProgram$.form.pax.$invalid,
                                    }"
                                />
                                <BFormInvalidFeedback
                                    :state="
                                        vProgram$.form.pax.$dirty &&
                                        vProgram$.form.pax.$invalid
                                    "
                                >
                                    {{
                                        vProgram$.form.pax.$errors[0]?.$message
                                    }}
                                </BFormInvalidFeedback>
                            </BFormGroup>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <BFormGroup
                                label-cols-sm="4"
                                label-cols-lg="3"
                                content-cols-sm
                                content-cols-lg="7"
                                label="Route"
                                label-for="route"
                            >
                                <v-select
                                    v-model="selectedRoute"
                                    id="route"
                                    label="name"
                                    :options="routeList"
                                    :searchable="true"
                                    :clearable="true"
                                    :loading="routeLoading"
                                    @open="getRouteList"
                                    placeholder="Select Route"
                                >
                                    <template
                                        #option="{ from, to, description }"
                                    >
                                        {{ from.name }} - {{ to.name }}
                                        {{
                                            description?.trim() != null
                                                ? `(${description})`
                                                : ""
                                        }}
                                    </template>

                                    <template
                                        #selected-option="{
                                            from,
                                            to,
                                            description,
                                        }"
                                    >
                                        {{ from.name }} - {{ to.name }}
                                        {{
                                            description?.trim() != null
                                                ? `(${description})`
                                                : ""
                                        }}
                                    </template>
                                </v-select>
                                <small class="text-muted"
                                    >Optional (only if a route already
                                    exists)</small
                                >
                            </BFormGroup>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <BFormGroup
                                label-cols-sm="4"
                                label-cols-lg="3"
                                content-cols-sm
                                content-cols-lg="7"
                                label="From *"
                                label-for="from_destination"
                            >
                                <v-select
                                    id="from_destination"
                                    v-model="formProgram.from_destination_uuid"
                                    label="name"
                                    :options="destinationList"
                                    :reduce="(item) => item.uuid"
                                    :searchable="true"
                                    :clearable="true"
                                    @option:selecting="setFromDestination"
                                    placeholder="Select Start Destination"
                                    :class="{
                                        'is-invalid':
                                            vProgram$.form.from_destination_uuid
                                                .$dirty &&
                                            vProgram$.form.from_destination_uuid
                                                .$invalid,
                                    }"
                                />
                                <BFormInvalidFeedback
                                    :state="
                                        vProgram$.form.from_destination_uuid
                                            .$dirty &&
                                        vProgram$.form.from_destination_uuid
                                            .$invalid
                                    "
                                >
                                    {{
                                        vProgram$.form.from_destination_uuid
                                            .$errors[0]?.$message
                                    }}
                                </BFormInvalidFeedback>
                            </BFormGroup>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <BFormGroup
                                label-cols-sm="4"
                                label-cols-lg="3"
                                content-cols-sm
                                content-cols-lg="7"
                                label="To *"
                                label-for="to_destination"
                            >
                                <v-select
                                    id="to_destination"
                                    v-model="formProgram.to_destination_uuid"
                                    label="name"
                                    :options="destinationList"
                                    :reduce="(item) => item.uuid"
                                    :searchable="true"
                                    :clearable="true"
                                    @option:selecting="setToDestination"
                                    placeholder="Select End Destination"
                                    :class="{
                                        'is-invalid':
                                            vProgram$.form.to_destination_uuid
                                                .$dirty &&
                                            vProgram$.form.to_destination_uuid
                                                .$invalid,
                                    }"
                                />
                                <BFormInvalidFeedback
                                    :state="
                                        vProgram$.form.to_destination_uuid
                                            .$dirty &&
                                        vProgram$.form.to_destination_uuid
                                            .$invalid
                                    "
                                >
                                    {{
                                        vProgram$.form.to_destination_uuid
                                            .$errors[0]?.$message
                                    }}
                                </BFormInvalidFeedback>
                            </BFormGroup>
                        </BCol>
                    </BRow>
                </BTab>
                <BTab title="Transportation">
                    <div class="d-flex justify-content-end mb-3">
                        <BButton
                            class="btn-cta"
                            variant="outline-primary"
                            @click="createModalTransportation"
                        >
                            <i class="fas fa-plus"></i>
                            Transportation
                        </BButton>
                    </div>
                    <div class="table-responsive">
                        <BTable
                            striped
                            hover
                            :items="transportationItems"
                            :fields="transportationHeader"
                            show-empty
                        >
                            <template #cell(no)="row">
                                {{ row.index + 1 }}
                            </template>
                            <template #cell(actions)="row">
                                <BButton
                                    size="sm"
                                    class="mx-1"
                                    @click="editTransportation(row)"
                                    variant="warning"
                                >
                                    <i class="ion ion-edit"></i
                                ></BButton>
                                <BButton
                                    size="sm"
                                    @click="removeTransportation(row.index)"
                                    variant="danger"
                                >
                                    <i class="ion ion-trash-b"></i
                                ></BButton>
                            </template>
                        </BTable>
                    </div>
                </BTab>
                <BTab title="Accomodation">
                    <div class="d-flex justify-content-end mb-3">
                        <BButton
                            class="btn-cta"
                            variant="outline-primary"
                            @click="createModalAccomodation"
                        >
                            <i class="fas fa-plus"></i>
                            Accomodation
                        </BButton>
                    </div>
                    <div class="table-responsive">
                        <BTable
                            striped
                            hover
                            :items="accomodationItems"
                            :fields="accomodationHeader"
                            show-empty
                        >
                            <template #cell(no)="row">
                                {{ row.index + 1 }}
                            </template>
                            <template #cell(extra_bed)="row">
                                <span
                                    :class="`badge badge-status text-${getBadgeExtraBed(
                                        row.item.extra_bed
                                    )} border border-${getBadgeExtraBed(
                                        row.item.extra_bed
                                    )}`"
                                >
                                    {{ row.item.extra_bed ? "Yes" : "No" }}
                                </span>
                            </template>
                            <template #cell(actions)="row">
                                <BButton
                                    size="sm"
                                    class="mx-1"
                                    @click="editAccomodation(row)"
                                    variant="warning"
                                >
                                    <i class="ion ion-edit"></i
                                ></BButton>
                                <BButton
                                    size="sm"
                                    @click="removeAccomodation(row.index)"
                                    variant="danger"
                                >
                                    <i class="ion ion-trash-b"></i
                                ></BButton>
                            </template>
                        </BTable>
                    </div>
                </BTab>
                <BTab title="Activity">
                    <div class="d-flex justify-content-end mb-3">
                        <BButton
                            class="btn-cta"
                            variant="outline-primary"
                            @click="createModalActivity"
                        >
                            <i class="fas fa-plus"></i>
                            Activity
                        </BButton>
                    </div>
                    <div class="table-responsive">
                        <BTable
                            striped
                            hover
                            :items="activityItems"
                            :fields="activityHeader"
                            show-empty
                        >
                            <template #cell(no)="row">
                                {{ row.index + 1 }}
                            </template>
                            <template #cell(actions)="row">
                                <BButton
                                    size="sm"
                                    class="mx-1"
                                    @click="editActivity(row)"
                                    variant="warning"
                                >
                                    <i class="ion ion-edit"></i
                                ></BButton>
                                <BButton
                                    size="sm"
                                    @click="removeActivity(row.index)"
                                    variant="danger"
                                >
                                    <i class="ion ion-trash-b"></i
                                ></BButton>
                            </template>
                        </BTable>
                    </div>
                </BTab>
                <BTab title="Meals">
                    <div class="d-flex justify-content-end mb-3">
                        <BButton
                            class="btn-cta"
                            variant="outline-primary"
                            @click="createModalMeal"
                        >
                            <i class="fas fa-plus"></i>
                            Meal
                        </BButton>
                    </div>
                    <div class="table-responsive">
                        <BTable
                            striped
                            hover
                            :items="mealItems"
                            :fields="mealHeader"
                            show-empty
                        >
                            <template #cell(no)="row">
                                {{ row.index + 1 }}
                            </template>
                            <template #cell(actions)="row">
                                <BButton
                                    size="sm"
                                    class="mx-1"
                                    @click="editMeal(row)"
                                    variant="warning"
                                >
                                    <i class="ion ion-edit"></i
                                ></BButton>
                                <BButton
                                    size="sm"
                                    @click="removeMeal(row.index)"
                                    variant="danger"
                                >
                                    <i class="ion ion-trash-b"></i
                                ></BButton>
                            </template>
                        </BTable>
                    </div>
                </BTab>
                <BTab title="Inclusion & Exclusion">
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <BFormGroup
                                label-cols-sm="4"
                                label-cols-lg="3"
                                content-cols-sm
                                content-cols-lg="7"
                                label="Inclusion"
                                label-for="inclusion"
                            >
                                <BFormTextarea
                                    v-model="formProgram.inclusion"
                                    type="text"
                                    id="inclusion"
                                    placeholder="Enter Inclusion"
                                    :rows="7"
                                    :class="{
                                        'is-invalid':
                                            vProgram$.form.inclusion.$dirty &&
                                            vProgram$.form.inclusion.$invalid,
                                    }"
                                >
                                </BFormTextarea>
                                <BFormInvalidFeedback
                                    :state="
                                        vProgram$.form.inclusion.$dirty &&
                                        vProgram$.form.inclusion.$invalid
                                    "
                                >
                                    {{
                                        vProgram$.form.inclusion.$errors[0]
                                            ?.$message
                                    }}
                                </BFormInvalidFeedback>
                            </BFormGroup>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <BFormGroup
                                label-cols-sm="4"
                                label-cols-lg="3"
                                content-cols-sm
                                content-cols-lg="7"
                                label="Exclusion"
                                label-for="exclusion"
                            >
                                <BFormTextarea
                                    v-model="formProgram.exclusion"
                                    type="text"
                                    id="exclusion"
                                    placeholder="Enter Exclusion"
                                    :rows="7"
                                    :class="{
                                        'is-invalid':
                                            vProgram$.form.exclusion.$dirty &&
                                            vProgram$.form.exclusion.$invalid,
                                    }"
                                >
                                </BFormTextarea>
                                <BFormInvalidFeedback
                                    :state="
                                        vProgram$.form.exclusion.$dirty &&
                                        vProgram$.form.exclusion.$invalid
                                    "
                                >
                                    {{
                                        vProgram$.form.exclusion.$errors[0]
                                            ?.$message
                                    }}
                                </BFormInvalidFeedback>
                            </BFormGroup>
                        </BCol>
                    </BRow>
                </BTab>
                <BTab title="Preview">
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <span class="fw-bold">Program Name</span>
                            <p>{{ formProgram?.name ?? "-" }}</p>
                        </BCol>
                        <BCol class="text-start">
                            <span class="fw-bold">Pax</span>
                            <p>{{ formProgram.pax ?? "-" }}</p>
                        </BCol>
                        <BCol class="text-start">
                            <span class="fw-bold">From</span>
                            <p>
                                {{
                                    formProgram?.from_destination
                                        ? formProgram?.from_destination?.name +
                                          " (" +
                                          formProgram?.from_destination?.code +
                                          ")"
                                        : "-"
                                }}
                            </p>
                        </BCol>
                        <BCol class="text-start">
                            <span class="fw-bold">To</span>
                            <p>
                                {{
                                    formProgram?.to_destination
                                        ? formProgram?.to_destination?.name +
                                          " (" +
                                          formProgram?.to_destination?.code +
                                          ")"
                                        : "-"
                                }}
                            </p>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <span class="fw-bold">1. Transportation</span>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered">
                                    <thead class="table-secondary">
                                        <tr>
                                            <th width="1" class="text-left">
                                                No
                                            </th>
                                            <th class="text-left">
                                                Vehicle Name
                                            </th>
                                            <th class="text-left">
                                                Vehicle Type
                                            </th>
                                            <th class="text-center">Pax</th>
                                            <th class="text-right col-sm-2">
                                                Price
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                item, index
                                            ) in transportationItems"
                                            :key="index"
                                        >
                                            <td class="text-left">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="text-left">
                                                {{ item.vehicle.name }}
                                            </td>
                                            <td class="text-left">
                                                {{ item.vehicle.type }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.pax }}
                                            </td>
                                            <td class="text-right">
                                                {{ formatRupiah(item.price) }}
                                            </td>
                                        </tr>
                                        <tr v-if="!transportationItems.length">
                                            <td class="text-center" colspan="5">
                                                No data available
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <span class="fw-bold">2. Accomodation</span>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered">
                                    <thead class="table-secondary">
                                        <tr>
                                            <th width="1" class="text-left">
                                                No
                                            </th>
                                            <th class="text-left">
                                                Destination
                                            </th>
                                            <th class="text-left">Hotel</th>
                                            <th class="text-left">RoomType</th>
                                            <th class="text-center">Pax</th>
                                            <th class="text-right">Price</th>
                                            <th class="text-center">
                                                Extra Bed
                                            </th>
                                            <th class="text-right">
                                                Extra Bed Price
                                            </th>
                                            <th class="text-right col-sm-2">
                                                Total Price
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                item, index
                                            ) in accomodationItems"
                                            :key="index"
                                        >
                                            <td class="text-left">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="text-left">
                                                {{
                                                    item.destination.name +
                                                    "(" +
                                                    item.destination.code +
                                                    ")"
                                                }}
                                            </td>
                                            <td class="text-left">
                                                {{ item.name }} ({{
                                                    item.code
                                                }})
                                            </td>
                                            <td class="text-left">
                                                {{ item.room_type }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.pax }}
                                            </td>
                                            <td class="text-right">
                                                {{ formatRupiah(item.price) }}
                                            </td>
                                            <td class="text-center">
                                                <span
                                                    :class="`badge badge-status text-${getBadgeExtraBed(
                                                        item.extra_bed
                                                    )} border border-${getBadgeExtraBed(
                                                        item.extra_bed
                                                    )}`"
                                                >
                                                    {{
                                                        item.extra_bed
                                                            ? "Yes"
                                                            : "No"
                                                    }}
                                                </span>
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    formatRupiah(
                                                        item.extra_bed_price
                                                    )
                                                }}
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    formatRupiah(
                                                        item.total_price
                                                    )
                                                }}
                                            </td>
                                        </tr>
                                        <tr v-if="!accomodationItems.length">
                                            <td class="text-center" colspan="9">
                                                No data available
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <span class="fw-bold">3. Activity</span>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered">
                                    <thead class="table-secondary">
                                        <tr>
                                            <th width="1" class="text-left">
                                                No
                                            </th>
                                            <th class="text-left">
                                                Destination
                                            </th>
                                            <th class="text-left">
                                                Activity Name
                                            </th>
                                            <th class="text-center">Pax</th>
                                            <th class="text-right col-sm-2">
                                                Price
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                item, index
                                            ) in activityItems"
                                            :key="index"
                                        >
                                            <td class="text-left">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="text-left">
                                                {{
                                                    item.destination.name +
                                                    "(" +
                                                    item.destination.code +
                                                    ")"
                                                }}
                                            </td>
                                            <td class="text-left">
                                                {{ item.name }}
                                            </td>
                                            <td class="text-center text-wrap">
                                                {{ item.pax }}
                                            </td>
                                            <td class="text-right">
                                                {{ formatRupiah(item.price) }}
                                            </td>
                                        </tr>
                                        <tr v-if="!activityItems.length">
                                            <td class="text-center" colspan="5">
                                                No data available
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <span class="fw-bold">4. Meals</span>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered">
                                    <thead class="table-secondary">
                                        <tr>
                                            <th width="1" class="text-left">
                                                No
                                            </th>
                                            <th class="text-left">Name</th>
                                            <th class="text-right col-sm-2">
                                                Price
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in mealItems"
                                            :key="index"
                                        >
                                            <td class="text-left">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="text-left">
                                                {{ item.name }}
                                            </td>
                                            <td class="text-right">
                                                {{ formatRupiah(item.price) }}
                                            </td>
                                        </tr>
                                        <tr v-if="!mealItems.length">
                                            <td class="text-center" colspan="3">
                                                No data available
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </BCol>
                    </BRow>

                    <BRow>
                        <BCol>
                            <div class="table-responsive">
                                <table class="table table-sm">
                                    <tbody>
                                        <tr style="font-size: 17px">
                                            <td
                                                class="text-start fw-bold text-2xl"
                                                colspan="2"
                                            >
                                                Total Price
                                            </td>
                                            <td
                                                class="text-end fw-bold fw-bold bg-success text-white col-sm-2"
                                            >
                                                {{
                                                    formProgram?.price
                                                        ? formatRupiah(
                                                              formProgram.price
                                                          )
                                                        : "Rp 0"
                                                }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </BCol>
                    </BRow>

                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <span class="fw-bold">Inclusion</span>
                            <ul v-if="formProgram.inclusion">
                                <li
                                    v-for="(
                                        item, index
                                    ) in formProgram.inclusion.split('\n')"
                                    :key="index"
                                >
                                    {{ item }}
                                </li>
                            </ul>
                            <p v-else>-</p>
                        </BCol>
                    </BRow>
                    <BRow class="mb-4">
                        <BCol class="text-start">
                            <span class="fw-bold">Exclusion</span>
                            <ul v-if="formProgram.exclusion">
                                <li
                                    v-for="(
                                        item, index
                                    ) in formProgram.exclusion.split('\n')"
                                    :key="index"
                                >
                                    {{ item }}
                                </li>
                            </ul>
                            <p v-else>-</p>
                        </BCol>
                    </BRow>
                </BTab>
            </BTabs>
            <template #footer>
                <div class="d-flex justify-content-end">
                    <BButton
                        @click="handleAction"
                        variant="primary"
                        class="me-2"
                        >Save</BButton
                    >
                    <BButton
                        type="button"
                        @click="() => router.back()"
                        variant="danger"
                        >Cancel</BButton
                    >
                </div>
            </template>
        </BCard>
    </BForm>
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import { ref, onMounted, reactive, watch } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minValue, minLength } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import TransportarionForm from "./TransportationForm.vue";
// import { useToast } from "vue-toastification";
// import { formatRupiah } from "@/utils/format";
import {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormTextarea,
    BRow,
    BTab,
    BTable,
    BTabs,
} from "bootstrap-vue-next";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { formatRupiah } from "@/utils/format";
import AccommodationForm from "./AccommodationForm.vue";
import ActivityForm from "./ActivityForm.vue";
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from "vue-router";
import MealForm from "./MealForm.vue";

const auth = useAuthStore();
const $loading = useLoading();

// const swal = inject("$swal");
const route = useRoute();
const router = useRouter();
const toast = useToast();

/*
 * **********************************************************
 * Transportation
 * **********************************************************
 */
const selectedTransportation = ref({});
const modalTransportation = ref(false);

const createModalTransportation = () => {
    selectedTransportation.value = {};
    modalTransportation.value = true;
};

const updateModalTransportation = (newVal) => {
    modalTransportation.value = newVal;
};

const addOrUpdateTransportation = (form) => {
    if (form.index !== undefined) {
        // Update data di posisi index
        form.price_format = formatRupiah(form.price);
        transportationItems.value[form.index] = {
            ...transportationItems.value[form.index],
            ...form,
        };
    } else {
        // Tambah data baru
        form.price_format = formatRupiah(form.price);
        transportationItems.value.push({ ...form });
    }

    combineInclusionExclusion();
    sumTotalPrice();
};

const editTransportation = (row) => {
    selectedTransportation.value = {
        index: row.index,
        ...row.item,
    };
    modalTransportation.value = true;
};

const removeTransportation = (index) => {
    transportationItems.value.splice(index, 1);
    combineInclusionExclusion();
    sumTotalPrice();
};

let transportationItems = ref([]);

const transportationHeader = [
    {
        key: "no",
        sortable: false,
    },
    {
        key: "name",
        label: "Name",
        sortable: true,
    },
    {
        key: "vehicle.name",
        label: "Vehicle Name",
        sortable: true,
    },
    {
        key: "vehicle.type",
        label: "Vehicle Type",
        sortable: false,
    },
    {
        key: "pax",
        label: "Pax",
        sortable: true,
    },
    {
        key: "price_format",
        label: "Price Per Pax",
        sortable: true,
    },
    {
        key: "sub_total",
        label: "Subtotal",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    {
        key: "actions",
        label: "#",
        sortable: false,
    },
];

/*
 * **********************************************************
 * Accomodation
 * **********************************************************
 */

const selectedAccomodation = ref({});
const modalAccomodation = ref(false);

const createModalAccomodation = () => {
    selectedAccomodation.value = {};
    modalAccomodation.value = true;
};

const updateModalAccomodation = (newVal) => {
    modalAccomodation.value = newVal;
};

const addOrUpdateAccomodation = (form) => {
    form.price_format = formatRupiah(form.price);
    form.destination_format =
        form.destination.name + " (" + form.destination.code + ")";
    if (form.index !== undefined) {
        // Update data di posisi index
        accomodationItems.value[form.index] = {
            ...accomodationItems.value[form.index],
            ...form,
        };
    } else {
        // Tambah data baru
        accomodationItems.value.push({ ...form });
    }
    combineInclusionExclusion();
    sumTotalPrice();
};

const editAccomodation = (row) => {
    selectedAccomodation.value = {
        index: row.index,
        ...row.item,
    };
    modalAccomodation.value = true;
};

const removeAccomodation = (index) => {
    accomodationItems.value.splice(index, 1);
    combineInclusionExclusion();
    sumTotalPrice();
};

let accomodationItems = ref([]);

const accomodationHeader = [
    {
        key: "no",
        label: "No",
        thClass: "text-center px-1",
        tdClass: "text-center px-1",
    },
    {
        key: "destination_format",
        label: "Destination",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "code",
        label: "Hotel Code",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "name",
        label: "Hotel Name",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "room_type",
        label: "Room Type",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "pax",
        label: "Pax",
        sortable: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "price",
        label: "Price Per Pax",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    {
        key: "sub_total",
        label: "Subtotal",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    {
        key: "extra_bed",
        label: "Extra Bed",
        sortable: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "extra_bed_price",
        label: "Extra Bed Price",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },

    {
        key: "total_price",
        label: "Total Price",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    { key: "actions", label: "Action" },
];

const getBadgeExtraBed = (key) => {
    switch (key) {
        case 1:
            return "success";
        default:
            return "secondary";
    }
};

/*
 *
 ************************************************
 *
 */

/*
 * **********************************************************
 * Activity
 * **********************************************************
 */

const selectedActivity = ref({});
const modalActivity = ref(false);

const createModalActivity = () => {
    selectedActivity.value = {};
    modalActivity.value = true;
};

const updateModalActivity = (newVal) => {
    modalActivity.value = newVal;
};

const addOrUpdateActivity = (form) => {
    form.price_format = formatRupiah(form.price);
    form.destination_format =
        form.destination.name + " (" + form.destination.code + ")";
    if (form.index !== undefined) {
        // Update data di posisi index
        activityItems.value[form.index] = {
            ...activityItems.value[form.index],
            ...form,
        };
    } else {
        // Tambah data baru
        activityItems.value.push({ ...form });
    }

    combineInclusionExclusion();
    sumTotalPrice();
};

const editActivity = (row) => {
    selectedActivity.value = {
        index: row.index,
        ...row.item,
    };
    modalActivity.value = true;
};

const removeActivity = (index) => {
    activityItems.value.splice(index, 1);
    combineInclusionExclusion();
    sumTotalPrice();
};

let activityItems = ref([]);

const activityHeader = [
    {
        key: "no",
        label: "No",
        thClass: "text-center px-1",
        tdClass: "text-center px-1",
    },
    {
        key: "destination_format",
        label: "Destination",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "name",
        label: "Activity Name",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "description",
        label: "Description",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left text-wrap",
        formatter: (value) => {
            if (!value) return "-";
            return value.length > 50 ? value.substring(0, 50) + "..." : value;
        },
    },
    {
        key: "pax",
        label: "Pax",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
    },
    {
        key: "price",
        label: "Price Per Pax",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => {
            if (!value) return "Rp 0";
            return formatRupiah(value);
        },
    },
    {
        key: "sub_total",
        label: "Subtotal",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    { key: "actions", label: "Action" },
];

/*
 * **********************************************************
 * Meals
 * **********************************************************
 */

const selectedMeal = ref({});
const modalMeal = ref(false);

const createModalMeal = () => {
    selectedMeal.value = {};
    modalMeal.value = true;
};

const updateModalMeal = (newVal) => {
    modalMeal.value = newVal;
};

const addOrUpdateMeal = (form) => {
    form.price_format = formatRupiah(form.price);

    if (form.index !== undefined) {
        // Update data di posisi index
        mealItems.value[form.index] = {
            ...mealItems.value[form.index],
            ...form,
        };
    } else {
        // Tambah data baru
        mealItems.value.push({ ...form });
    }
    sumTotalPrice();
};

const editMeal = (row) => {
    selectedMeal.value = {
        index: row.index,
        ...row.item,
    };
    modalMeal.value = true;
};

const removeMeal = (index) => {
    mealItems.value.splice(index, 1);
    sumTotalPrice();
};

let mealItems = ref([]);

const mealHeader = [
    {
        key: "no",
        label: "No",
        thClass: "text-center px-1",
        tdClass: "text-center px-1",
    },
    {
        key: "name",
        label: "Name",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "price_format",
        label: "Price Per Pax",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
    },
    {
        key: "sub_total",
        label: "Subtotal",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    { key: "actions", label: "Action" },
];

/*
 *
 ************************************************
 *
 */

//Meals Name Option
// const mealsNameOptions = [
//     {
//         value: "Lunch",
//         text: "Lunch",
//     },
//     {
//         value: "Dinner",
//         text: "Dinner",
//     },
// ];

// const combineInclusionExclusion = () => {
//     const allInclusions = [
//         ...accomodationItems.value.map((item) => item.inclusion || ""),
//         ...transportationItems.value.map((item) => item.inclusion || ""),
//         ...activityItems.value.map((item) => item.inclusion || ""),
//     ].filter(Boolean); // hapus kosong

//     // Gabungkan semua exclusion
//     const allExclusions = [
//         ...accomodationItems.value.map((item) => item.exclusion || ""),
//         ...transportationItems.value.map((item) => item.exclusion || ""),
//         ...activityItems.value.map((item) => item.exclusion || ""),
//     ].filter(Boolean);

//     // Simpan ke form (dipisah baris baru)
//     formProgram.inclusion = allInclusions.join("\n");
//     formProgram.exclusion = allExclusions.join("\n");
// };

const combineInclusionExclusion = () => {
    const allInclusions = [];
    const allExclusions = [];

    const allItems = [
        ...accomodationItems.value,
        ...transportationItems.value,
        ...activityItems.value,
    ];

    allItems.forEach((item) => {
        // === Handle Inclusion ===
        if (item?.inclusion) {
            // pisah berdasarkan newline, bersihkan tiap baris
            const inclusions = item.inclusion
                .split("\n")
                .map((v) => v.replace(/\s+/g, " ").trim()) // hapus spasi/tab ganda
                .filter(Boolean);

            inclusions.forEach((val) => {
                // cek duplikat tanpa peduli huruf besar
                if (!allInclusions.some((v) => v.toLowerCase() === val.toLowerCase())) {
                    allInclusions.push(val);
                }
            });
        }

        // === Handle Exclusion ===
        if (item?.exclusion) {
            const exclusions = item.exclusion
                .split("\n")
                .map((v) => v.replace(/\s+/g, " ").trim())
                .filter(Boolean);

            exclusions.forEach((val) => {
                if (!allExclusions.some((v) => v.toLowerCase() === val.toLowerCase())) {
                    allExclusions.push(val);
                }
            });
        }
    });

    // Simpan ke form
    formProgram.inclusion = allInclusions.join("\n");
    formProgram.exclusion = allExclusions.join("\n");

};

const sumTotalPrice = () => {
    const safeNumber = (val) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
    };

    const totalTransportation = transportationItems.value.reduce(
        (sum, item) => sum + safeNumber(item.price),
        0
    );
    const totalAccomodation = accomodationItems.value.reduce(
        (sum, item) => sum + safeNumber(item.total_price),
        0
    );
    const totalActivity = activityItems.value.reduce(
        (sum, item) => sum + safeNumber(item.price),
        0
    );
    const totalMeal = mealItems.value.reduce(
        (sum, item) => sum + safeNumber(item.price),
        0
    );

    formProgram.price =
        safeNumber(totalTransportation) +
        safeNumber(totalAccomodation) +
        safeNumber(totalActivity) +
        safeNumber(totalMeal);
};

// Program

const formProgramData = {
    uuid: "",
    name: "",
    pax: "",
    from_destination_uuid: "",
    from_destination: "",
    to_destination_uuid: "",
    to_destination: "",
    transportation: [],
    accommodation: [],
    activity: [],
    meals: [],
    price: "",
    inclusion: "",
    exclusion: "",
};

const formProgram = reactive({ ...formProgramData });

const rules = {
    form: {
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3",
                minLength(3)
            ),
        },
        pax: {
            required: helpers.withMessage("Pax is required", required),
            minValue: helpers.withMessage(
                "Pax must be at least 1",
                minValue(1)
            ),
        },
        from_destination_uuid: {
            required: helpers.withMessage(
                "Start destination is required",
                required
            ),
        },
        to_destination_uuid: {
            required: helpers.withMessage(
                "End destination is required",
                required
            ),
        },
        price: "",
        inclusion: {},
        exclusion: {},
    },
};

const vProgram$ = useVuelidate(rules, { form: formProgram });

const handleAction = () => {
    route.params.uuid != undefined ? update() : null;
};

// const create = async () => {
//     toast.clear();
//     vProgram$.value.$touch();
//     if (!vProgram$.value.$invalid) {
//         const loader = $loading.show({
//             color: "#489464",
//             loader: "spinner",
//         });

//         try {
//             const response = await axios.post(
//                 `${process.env.VUE_APP_API_URL}/program/add`,
//                 {
//                     name: formProgram.name,
//                     pax: formProgram.pax,
//                     from_destination_uuid: formProgram.from_destination_uuid,
//                     to_destination_uuid: formProgram.to_destination_uuid,
//                     transportation: transportationItems.value,
//                     accommodation: accomodationItems.value,
//                     activity: activityItems.value,
//                     meals: mealItems.value,
//                     inclusion: formProgram.inclusion,
//                     exclusion: formProgram.exclusion,
//                 },
//                 {
//                     headers: {
//                         "Content-type": "application/json",
//                         Authorization: "Bearer " + auth._token,
//                     },
//                 }
//             );

//             const res = response.data;

//             if (res.status) {
//                 toast.success(res.message);
//                 router.push("/programs");
//             }
//         } finally {
//             loader.hide();
//         }
//     } else {
//         const firstErrorField = Object.keys(vProgram$.value).find(
//             (key) => vProgram$.value[key]?.$errors?.length
//         );
//         if (firstErrorField) {
//             const errorMsg =
//                 vProgram$.value[firstErrorField].$errors[0].$message;
//             toast.warning(errorMsg);
//         }
//     }
// };

const update = async () => {
    toast.clear();
    vProgram$.value.$touch();
    if (!vProgram$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/package/program/edit/${route.params.uuid}`,
                {
                    name: formProgram.name,
                    pax: formProgram.pax,
                    from_destination_uuid: formProgram.from_destination_uuid,
                    to_destination_uuid: formProgram.to_destination_uuid,
                    transportation: transportationItems.value,
                    accommodation: accomodationItems.value,
                    activity: activityItems.value,
                    meals: mealItems.value,
                    inclusion: formProgram.inclusion,
                    exclusion: formProgram.exclusion,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                toast.success(res.message);
                router.back();
            }
        } finally {
            loader.hide();
        }
    } else {
        const firstErrorField = Object.keys(vProgram$.value).find(
            (key) => vProgram$.value[key]?.$errors?.length
        );

        console.log(vProgram$);

        if (firstErrorField) {
            const errorMsg =
                vProgram$.value[firstErrorField].$errors[0].$message;
            toast.error(errorMsg);
        }
    }
};

const selectedRoute = ref(null);
let routeList = ref([]);
let routeLoading = ref(false);

const getRouteList = async () => {
    routeLoading.value = true;

    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/route`,
            {
                params: {
                    pax: formProgram.pax,
                },
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            routeList.value = res.data.map((r) => ({
                ...r,
                name: `${r.from.name} - ${r.to.name}`,
            }));

            if (routeList.value.length > 0) {
                selectedRoute.value = routeList.value[0];
            } else {
                selectedRoute.value = [];
            }
        }
    } finally {
        routeLoading.value = false;
    }
};

let destinationList = ref([]);

const getAllDestination = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/destination`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            destinationList.value = res.data;
        }
    } finally {
        loader.hide();
    }
};

const getProgram = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/package/program/${route.params.uuid}`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            const data = res.data;

            formProgram.name = data.name;
            formProgram.pax = data.pax;
            formProgram.from_destination = data.from_destination;
            formProgram.to_destination = data.to_destination;
            formProgram.from_destination_uuid = data.from_destination_uuid;
            formProgram.to_destination_uuid = data.to_destination_uuid;
            formProgram.inclusion = data.inclusion;
            formProgram.exclusion = data.exclusion;
            if (data.transportation && Array.isArray(data.transportation)) {
                transportationItems.value = data.transportation.map((item) => ({
                    ...item,
                    price_format: formatRupiah(item.price),
                }));
            }

            if (data.accommodation && Array.isArray(data.accommodation)) {
                accomodationItems.value = data.accommodation.map((item) => ({
                    ...item,
                    destination_format:
                        item.destination.name +
                        " (" +
                        item.destination.code +
                        ")",
                    price_format: formatRupiah(item.price),
                }));
            }

            if (data.activity && Array.isArray(data.activity)) {
                activityItems.value = data.activity.map((item) => ({
                    ...item,
                    destination_format:
                        item.destination.name +
                        " (" +
                        item.destination.code +
                        ")",
                    price_format: formatRupiah(item.price),
                }));
            }

            if (data.meals && Array.isArray(data.meals)) {
                mealItems.value = data.meals.map((item) => ({
                    ...item,
                    price_format: formatRupiah(item.price),
                }));
            }

            sumTotalPrice();
        }
    } finally {
        loader.hide();
    }
};

const setFromDestination = (val) => {
    formProgram.from_destination = val;
};

const setToDestination = (val) => {
    formProgram.to_destination = val;
};

watch(selectedRoute, (val) => {
    if (val && val.from && val.to) {
        formProgram.from_destination_uuid = val.from.uuid;
        formProgram.from_destination = val.from;
        formProgram.to_destination_uuid = val.to.uuid;
        formProgram.to_destination = val.to;
    } else {
        formProgram.from_destination_uuid = null;
        formProgram.to_destination_uuid = null;
        formProgram.from_destination = null;
        formProgram.to_destination = null;
    }
});

onMounted(async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAllDestination();
        if (route.params.uuid) {
            await getProgram();
        }
    } finally {
        loader.hide();
    }
});
</script>
